import React, { Component } from "react";
import PubSub from "pubsub-js";
import {
	PriceColorStatus,
	LATAM_BONUS_END_DATE,
	LATAM_BONUS_START_AVERAGE,
	LATAM_BONUS_END_AVERAGE,
	LATAM_BONUS_MAX_PRICE,
	LATAM_BONUS_BEST_AVERAGE,
	GOL_BONUS_START_AVERAGE,
	GOL_BONUS_END_AVERAGE,
	GOL_BONUS_MAX_PRICE,
	GOL_BONUS_BEST_AVERAGE,
	MANAGER_LIMIT_AVERAGE_MILES
} from "./../../../shared/enums";
import {
	getFidelities,
	getRankPriceByFidelityAndMiles,
	getPricesByFidelityAndMiles,
	getMilesStatistics
} from "./../../../shared/requests-api";
import { formatCurrency, intFormat } from "./../../../../../js/shared/utils";
import Steps from "./Steps";
import InputCurrency from "../../../../shared/InputCurrency/InputCurrency";
import Select from "../../../../shared/Select/Select";
import Modal from "../../../../shared/Modal/Modal";
import Range from "../../../../shared/Range/Range";
import Checkbox from "../../../../shared/Checkbox/Checkbox";
import Radio from "../../../../shared/Radio/Radio";
import {
	isAllFieldsEmpty,
	getUserToken,
	findAverageMessage,
	isTodayBefore,
	fidelityHasAverage,
	scrollToComponent
} from "../../../shared/utils";
import Loading from "../../../../shared/Loading/Loading";
import { isMobile } from "../../../../../js/components/searchform/utils/common";
import { ROUTE_HOME } from "../../../shared/constants";
import Button from "../../../../shared/button/button";
import Switch from "../../../../shared/Switch/Switch";
import FidelityBonus from "./components/FidelityBonus";
import {
	VinduloPendenteModal,
	OfertaEmVendaModal,
	EditarOfertaModal
} from "../../../services/modals";

let timeout;
let defaultFidelity = {
	label: isMobile() ? "Selecione o programa..." : "Selecione o programa de fidelidade",
	value: ""
};
let initialState = {
	airlines: [],
	locale: "1",
	fidelity: defaultFidelity,
	fidelityId: "",
	fidelityPrice: null,
	priceState: null,
	price: 0,
	valMinMiles: 0,
	valMaxMiles: 9999999,
	errors: {
		quantMiles: undefined,
		price: undefined
	},
	fidelitiesOptions: undefined,
	showConfiguracoesAvancadas: false,
	showSmilesCheckbox: false,
	reducaoOptions: [],
	passengersAvailable: 0,
	maxEligableQuant: 0,
	minEligableQuant: 0,
	passengersCount: 0,
	eligableAverage: "",
	eligableQuant: "",
	eligableColor: "",
	bonusMaxPrice: 0,
	startAverage: 0,
	endAverage: 0,

	editarOfertaModal: false
};

class SimulatorMiles extends Component {
	constructor() {
		super();
		this.state = initialState;
		this.first = true;
		this.globalQuantMiles = undefined;
		this.globalFidelityId = undefined;

		this.submitAndNextStep = this.submitAndNextStep.bind(this);
		this.validateFidelity = this.validateFidelity.bind(this);
		this.handleProps = this.handleProps.bind(this);
		this.confirmNextStep = this.confirmNextStep.bind(this);
		this.validForm = this.validForm.bind(this);
		this.validateQuantMiles = this.validateQuantMiles.bind(this);
		this.validatePrice = this.validatePrice.bind(this);
		this.cancelModal = this.cancelModal.bind(this);
		this.confirmModal = this.confirmModal.bind(this);
		this.changeFidelity = this.changeFidelity.bind(this);
		this.filterAirlines = this.filterAirlines.bind(this);
		this.updateValuesAirline = this.updateValuesAirline.bind(this);
		this.changeAverageSlider = this.changeAverageSlider.bind(this);
		this.hideAvisoProblema = this.hideAvisoProblema.bind(this);
		this.hideAvisoVenda = this.hideAvisoVenda.bind(this);
		this.hideAvisoParticipant = this.hideAvisoParticipant.bind(this);
		this.changeReducao = this.changeReducao.bind(this);
		this.changeMedia = this.changeMedia.bind(this);
		this.calcMedia = this.calcMedia.bind(this);
		this.confirmAverageSelect = this.confirmAverageSelect.bind(this);
		this.cancelAverageSelect = this.cancelAverageSelect.bind(this);
		this.changeSmilesCheckbox = this.changeSmilesCheckbox.bind(this);
		this.focusInputPrice = this.focusInputPrice.bind(this);
		this.showAndScrollToBonus = this.showAndScrollToBonus.bind(this);
	}

	componentDidMount() {
		const { form } = this.props;

		if (form) {
			this.setState(form);
		}

		this.handleProps(this.props);
	}

	componentWillReceiveProps(nextProps) {
		this.handleProps(nextProps);
	}

	handleProps(props) {
		const { form, selected } = props;
		let fidelity = props.fidelity;
		const token = getUserToken();
		let locale = this.state.locale;

		if (form) {
			locale = form.locale || locale;
			this.setState({ locale: locale });
		}

		let self = this;

		if (fidelity && (!form || !form.quantMiles)) {
			const { airlines, fidelitiesOptions } = self.filterAirlines([fidelity], fidelity);
			self.setState({ airlines, fidelitiesOptions });
			self.changeFidelity(fidelity, true, props);
		} else {
			getFidelities(token, locale).then(response => {
				if (self._unmounted) return;
				const { airlines, fidelitiesOptions } = self.filterAirlines(response.data);
				self.setState({ airlines, fidelitiesOptions });

				if (form && (form.logged || selected)) {
					form.logged = false;
					if (self.validateFidelity(props, form.fidelityId)) {
						// Ter o mesmo fluxo do editar, só que vindo da tela deslogada
						const { offers } = props;
						let found;
						if (offers && offers.length) {
							found = offers.find(offer => offer.fidelity.id == form.fidelityId);
						}

						// Preenche as informações auxiliares pra saber se precisa atualizar ou então editar
						if (found) {
							form.fidelity.offerId = found.id;
							form.fidelity.status = found.status;
							form.fidelity.editable = found.editable;
							form.fidelity.hasBonus = found.hasBonus;
							form.fidelity.isSmilesDiamond = found.isSmilesDiamond; // categoria diamante
							form.fidelity.reductionsLimit = found.reductionsLimit; // teto smiles
						}
						form.fidelity.quant = form.quantMiles;
						form.fidelity.price = form.price;
						form.fidelity.averageMiles = form.averageMiles;
						self.changeFidelity(form.fidelity, true);
					} else {
						self.setState({
							fidelity: defaultFidelity,
							fidelityId: undefined,
							errors: {
								quantMiles: undefined,
								price: undefined
							}
						});
					}
				}
			});
		}
	}

	componentWillUnmount() {
		this._unmounted = true;
		this.first = true;
	}

	validateFidelity(props, fidelityId) {
		const { offers } = props;

		let found;
		if (offers && offers.length) {
			found = offers.find(offer => offer.fidelity.id == fidelityId);
		}

		if (found) {
			// Em venda
			if (found.status == 3) {
				this.setState({ showAvisoVenda: true, quantMiles: 0, price: 0 });
				return false;
			}

			// Em venda
			if (found.editable === false) {
				this.setState({ showAvisoProblema: true, quantMiles: 0, price: 0 });
				return false;
			}
		}

		return true;
	}

	changeFidelity = (option, preserveQuant, props) => {
		const { fidelityId, errors, quantMiles } = this.state;
		let { offer } = props || this.props;
		let self = this;

		// Em venda
		if (option.status == 3) {
			this.setState({ showAvisoVenda: true });
			return;
		}

		// Em venda
		if (option.editable === false) {
			this.setState({ showAvisoProblema: true });
			return;
		}

		// Verifica se tem que mostrar aviso de zerar
		if (
			fidelityId &&
			fidelityId != option.value &&
			!localStorage.getItem("SimulatorMilesAviso") &&
			quantMiles
		) {
			this.setState({ showZerarSimulador: true, pendentFidelity: option });
			return;
		}

		let valMinMiles = 3500,
			valMaxMiles = 9999999;

		// Procura o valor maximo e minimo de milhas
		option.fidelities.forEach(f => {
			if (f.id == option.value) {
				valMinMiles = f.valMinMiles;
				valMaxMiles = f.valMaxMiles;
			}
		});

		if (option.quant && option.price) {
			offer = option;
			preserveQuant = true;
			this.first = true;
		}

		this.globalFidelityId = option.value;

		if (fidelityHasAverage(this.globalFidelityId)) {
			getMilesStatistics(this.globalFidelityId).then(response => {
				if (self._unmounted) return;
				self.setState({ statistics: response.data });
			});
		}

		this.changingFidelity = true;
		if (preserveQuant) {
			//errors.price = "";
			//errors.quantMiles = "";

			this.globalFidelityId = option.value || (offer ? offer.fidelity.id : undefined);

			if (offer && this.first) {
				this.first = false;
				this.setState(
					{
						fidelityId: option.value || (offer ? offer.fidelity.id : undefined),
						fidelity: option
					},
					() => {
						this.searchPrices(
							offer.quant,
							offer.quant,
							() => {
								this.searchPriceState(offer.price, offer.price);
							},
							option.value || offer.fidelity.id,
							offer.averageMiles,
							offer.isSmilesDiamond,
							offer.reductionsLimit
						);
					}
				);
			} else {
				this.setState({ showMedia: false });
				this.changingFidelity = false;
			}

			if (offer && offer.quant < valMinMiles) {
				errors.quantMiles = `A oferta precisa ter no mínimo ${intFormat(valMinMiles)} milhas`;
			}
			this.setState({
				fidelityId: option.value || (offer ? offer.fidelity.id : undefined),
				fidelity: option,
				valMinMiles,
				valMaxMiles,
				quantMiles: offer ? offer.quant : quantMiles,
				price: offer ? offer.price : undefined,
				errors,
				showZerarSimulador: false,
				showFidelityBonus: false,
				loginRequestDone: false // refazer request do login
			});
		} else {
			this.changingFidelity = false;
			errors.quantMiles = undefined;
			errors.price = undefined;
			errors.fidelity = undefined;

			this.setState({
				fidelityId: option.value,
				fidelity: option,
				valMinMiles,
				valMaxMiles,
				quantMiles: undefined,
				price: 0,
				fidelityPrice: undefined,
				ranks: undefined,
				priceState: undefined,
				showMedia: false,
				showZerarSimulador: false,
				errors,
				showReducao: false,
				media: undefined,
				reducao: undefined,
				showFidelityBonus: false,
				loginRequestDone: false // refazer request do login
			});
		}
	};

	changeFidelityRadio = option => {
		const { fidelity } = this.state;

		fidelity.value = option.value;
		fidelity.name = option.label;
		this.changeFidelity(fidelity);
	};

	renderFidelityRadio = () => {
		const { isIframe } = this.props;
		const { fidelity, fidelityId } = this.state;

		if (fidelity && fidelity.fidelities && fidelity.fidelities.length > 1) {
			let radioOptions = fidelity.fidelities.map(f => {
				return {
					value: f.id,
					label: f.name,
					checked: fidelityId == f.id
				};
			});

			return (
				<div className="col-xs-16">
					<div
						className="form-group categoria-fidelity"
						style={isMobile() ? {} : { display: "inline-flex" }}
					>
						<label htmlFor="radio-fidelity">Categoria: </label>
						<Radio
							id="radio-fidelity"
							name="radio-fidelity"
							onChange={this.changeFidelityRadio}
							options={radioOptions}
							horizontally={!isMobile() || isIframe}
							data-action="simulator-miles-category-radio"
						/>
					</div>
				</div>
			);
		}
		return null;
	};

	searchFidelities = locale => {
		let self = this;
		this.setState({ locale: locale, airlines: [] });

		getFidelities(undefined, locale).then(response => {
			if (self._unmounted) return;
			const { airlines, fidelitiesOptions } = self.filterAirlines(response.data);
			self.setState({ airlines, fidelitiesOptions });
		});
	};

	filterAirlines(airlines, prevFidelity) {
		let offers = this.props.offers;
		let offerProp = this.props.offer;

		// Remover programas que ja tem oferta ativa
		if (offers && offers.length && airlines) {
			for (let index = airlines.length - 1; index >= 0; index--) {
				let airline = airlines[index];

				if (airline.fidelities) {
					for (let index2 = airline.fidelities.length - 1; index2 >= 0; index2--) {
						let f = airline.fidelities[index2];

						if (!f) {
							continue;
						}

						offers.forEach(offer => {
							if (offer.fidelity.id == f.id) {
								airline.fidelityId = f.id;
								airline.offerId = offer.id;
								airline.status = offer.status;
								if (
									prevFidelity &&
									prevFidelity.value == f.id &&
									prevFidelity.quant &&
									prevFidelity.price
								) {
									airline.quant = prevFidelity.quant;
									airline.price = prevFidelity.price;
								} else {
									airline.quant = offerProp ? offerProp.quant : offer.quant;
									airline.price = offerProp ? offerProp.price : offer.price;
								}

								airline.name = offer.fidelity.name;
								airline.editable = offer.editable;
								airline.averageMiles = offer.averageMiles;
								airline.hasBonus = offer.hasBonus;
								airline.isSmilesDiamond = offer.isSmilesDiamond;
								airline.reductionsLimit = offer.reductionsLimit;
							}
						});
					}
				}
			}
		}

		let fidelitiesOptions = airlines
			? airlines.map(airline => {
					let fidelity = airline.fidelities.sort((a, b) =>
						a.name < b.name ? -1 : a.name > b.name ? 1 : 0
					)[0];

					if (!fidelity || !fidelity.id) {
						return {};
					}

					return {
						value: airline.fidelityId || fidelity.id,
						label: airline.label || airline.airlineAcronym,
						highlight: airline.name || fidelity.name,
						name: airline.name || fidelity.name,
						link: fidelity.link,
						fidelities: airline.fidelities,
						offerId: airline.offerId,
						status: airline.status,
						editable: airline.editable,
						quant: airline.quant,
						price: airline.price,
						averageMiles: airline.averageMiles,
						hasBonus: airline.hasBonus,
						isSmilesDiamond: airline.isSmilesDiamond,
						reductionsLimit: airline.reductionsLimit,
						valMinMiles: fidelity.valMinMiles
					};
			  })
			: [];

		return { airlines, fidelitiesOptions };
	}

	updateValuesAirline(quant, price, fidelityId) {
		const { fidelitiesOptions } = this.state;

		// Remover programas que ja tem oferta ativa
		if (fidelitiesOptions && fidelitiesOptions.length) {
			for (let i = 0; i < fidelitiesOptions.length; i++) {
				let fidelity = fidelitiesOptions[i];

				if (fidelity.value == fidelityId) {
					if (quant) {
						fidelity.quant = quant;
					}

					if (price) {
						fidelity.price = price;
					}

					this.setState({ fidelitiesOptions, fidelity });
					break;
				}
			}
		}
	}

	willShowAverage(quantMiles, fidelity, nextFidelityId) {
		if (quantMiles < 60000) {
			return false;
		}

		if (fidelity.label == "Latam" || nextFidelityId == 1 || nextFidelityId == 3) {
			return true;
		} else if (fidelity.label == "Azul" || nextFidelityId == 5) {
			return true;
		} else if (fidelity.label == "Gol" || nextFidelityId == 4) {
			return true;
		}

		return false;
	}

	searchPrices = (
		fmt,
		quantMiles,
		callback,
		nextFidelityId,
		offerAverageMiles,
		isSmilesDiamond,
		reductionsLimit
	) => {
		const token = getUserToken();
		const { offer, hasManagementActive } = this.props;
		const { errors, price, fidelity } = this.state;
		let fidelityId = this.state.fidelityId;

		isSmilesDiamond =
			fidelity.isSmilesDiamond != undefined ? fidelity.isSmilesDiamond : isSmilesDiamond;
		reductionsLimit =
			fidelity.reductionsLimit != undefined ? fidelity.reductionsLimit : reductionsLimit;

		errors.price = undefined;
		if (offer) {
			//fidelityId = offer.fidelity.id;
			if (offer.quant == quantMiles && offer.price == price) {
				errors.price = "";
			}
		}

		if (nextFidelityId) {
			fidelityId = nextFidelityId;
		}

		// Caso não tenha preenchido a variavel de controle pros request
		if (!this.globalFidelityId) {
			this.globalFidelityId = fidelityId;
		}

		this.setState({
			quantMiles: quantMiles,
			eligableColor: "",
			//price: 0,
			priceState: undefined,
			errors,
			loadingPrice: false,
			showMedia: false,
			ranks: undefined,
			fidelityPrice: undefined,
			showReducao: false,
			media: undefined,
			reducao: undefined
		});

		this.globalQuantMiles = quantMiles;

		let self = this;

		if (this.validateQuantMiles(quantMiles)) {
			let showMedia = this.willShowAverage(quantMiles, fidelity, nextFidelityId);

			this.setState({
				loadingPrice: true
			});

			this.updateValuesAirline(quantMiles, 0, fidelityId);

			if (token) {
				clearTimeout(timeout);
				timeout = setTimeout(
					() => {
						getRankPriceByFidelityAndMiles(token, fidelityId, quantMiles, 50)
							.then(response => {
								if (self._unmounted) return;

								// ignorar request se o valor mudou
								if (quantMiles != this.globalQuantMiles || fidelityId != this.globalFidelityId) {
									return;
								}

								self.setState(
									{
										fidelityPrice: response.data,
										ranks: response.data.rank,
										loadingPrice: false,
										showReducao: false,
										media: undefined
									},
									() => self.validatePrice(self.state.price)
								);

								let averageMilesSuggest = response.data.averageMilesSuggestion;
								let averageMiles =
									!(hasManagementActive && offerAverageMiles > MANAGER_LIMIT_AVERAGE_MILES) && // caso tiver vinculo ativo e a media for maior que limite, então pega a sugestão
									offerAverageMiles >= 3500
										? offerAverageMiles
										: averageMilesSuggest;

								if (!averageMiles && !response.data.countAllowedSales) {
									averageMiles = quantMiles;
								}

								/*
							if (fidelityId == 1) {
								// platinum
								averageMiles = offerAverageMiles || averageMilesSuggest;
							}*/

								if (showMedia) {
									self.searchAverage(
										averageMiles,
										averageMiles,
										undefined,
										averageMilesSuggest,
										quantMiles
									);

									if (fidelityId == 4 && !hasManagementActive) {
										// Não pode ter vinculo ativo
										// smiles/gol/teto 35k
										let countAllowedSales = response.data.countAllowedSales || 0;
										let usedReductions = response.data.usedReductions || 0;

										let menorQtdeReducao = Math.min(
											10 - usedReductions,
											countAllowedSales,
											parseInt((quantMiles || 0) / 35000)
										);

										if (menorQtdeReducao > 0) {
											let reducaoOptions = Array(menorQtdeReducao + 1)
												.fill()
												.map((_, i) => {
													return {
														label: `${String(i)} passage${i > 1 ? "ns" : "m"}`,
														value: i
													};
												});

											let reducao = reducaoOptions[reducaoOptions.length - 1];
											reducao =
												(fidelity.status === 1 || fidelity.status === 2) && // Apenas quando tiver oferta ativa/analise
												reductionsLimit !== undefined
													? reducaoOptions.find(r => r.value == reductionsLimit) || reducao
													: reducao;

											self.setState(
												{
													reducao,
													reducaoOptions,
													showReducao: true
												},
												() => {}
											);

											if (isSmilesDiamond) {
												self.calcMedia(
													countAllowedSales,
													reducao,
													quantMiles,
													reductionsLimit !== undefined ? averageMiles : undefined
												);
											}
										}
									}
								}

								if (callback) {
									callback();
								}
								this.changingFidelity = false;
							})
							.catch(resp => {
								self.setState({ loadingPrice: false });
							});
					},
					fmt == quantMiles ? 0 : 500
				);
			} else {
				getPricesByFidelityAndMiles(fidelityId, quantMiles)
					.then(response => {
						if (self._unmounted) return;

						// ignorar request se o valor mudou
						if (quantMiles != this.globalQuantMiles) {
							return;
						}

						self.setState({
							fidelityPrice: response.data,
							loadingPrice: false
						});

						this.changingFidelity = false;
					})
					.catch(resp => {
						self.setState({ loadingPrice: false });
					});
			}
		} else {
			this.changingFidelity = false;
		}
	};

	searchPriceState = (fmt, price) => {
		const {
			quantMiles,
			ranks,
			fidelityId,
			fidelityPrice,
			bonusMaxPrice,
			eligableColor
		} = this.state;
		let self = this;
		this.setState({ price, priceState: undefined });

		if (this.validatePrice(price)) {
			if (
				!this.changingFidelity &&
				eligableColor == "green" &&
				this.state.validPrice <= fidelityPrice.maxPrice &&
				price >= fidelityPrice.maxPrice
			) {
				console.log("Alterou valor das milhas para faixa dinâmica");
				PubSub.publish("dataLayer", {
					event: "gaEvent",
					gaEventCategory: "Minhas ofertas",
					gaEventAction: "Cadastro de oferta",
					gaEventLabel: "Alterou valor das milhas para faixa dinâmica",
					gaEventValue: ""
				});
			}

			this.setState({ validPrice: price });
			let priceState;
			if (ranks && ranks.length) {
				let myPositionPassed = false;
				for (let idx = 0; idx <= ranks.length; idx++) {
					let rank = ranks[idx];
					let priceRank;

					if (rank) {
						priceRank = parseFloat(rank.price.replace(",", "."));
						myPositionPassed = myPositionPassed || rank.myPosition; // saber se passamos nossa própria posição
						if (rank.position > 50) {
							// quando o proprio usuario ja tem rank na oferta ele aparece em último
							idx++;
						}
					} else {
						priceRank = 9999999; // valor maximo
					}

					if (price < priceRank) {
						priceState = {
							rank: myPositionPassed ? idx : idx + 1, // caso passou da posição não precisa de incremento
							sale: idx >= 10 ? "orange" : "green"
						};
						break;
					}
				}

				if (!priceState || priceState.rank >= 51) {
					priceState = {
						rank: ">50",
						sale: "red"
					};
				}
			} else if (getUserToken()) {
				priceState = {
					rank: "1",
					sale: "green"
				};
			}

			self.setState({
				priceState
			});

			self.updateValuesAirline(quantMiles, price, fidelityId);
		}
	};

	findStatisticalSales = averageMiles => {
		const { statistics } = this.state;
		let percentage = 1;

		for (var statistic in statistics) {
			if (
				statistics[statistic].finalMiles >= averageMiles &&
				statistics[statistic].initialMiles <= averageMiles
			) {
				percentage = statistics[statistic].percentage;
			}
		}

		return percentage.toString().replace(".", ",");
	};

	searchAverage = (fmt, averageMiles, event, averageMilesSuggest, quantMiles) => {
		const { fidelity } = this.state;
		let showConfiguracoesAvancadas = this.state.showConfiguracoesAvancadas || !averageMiles;
		averageMilesSuggest =
			averageMilesSuggest != undefined ? averageMilesSuggest : this.state.averageMilesSuggest;

		let averageMessage = findAverageMessage(
			averageMiles,
			averageMilesSuggest,
			fidelity,
			this.findStatisticalSales(averageMiles)
		);
		this.validateAverage(averageMiles, quantMiles);
		this.setState(
			{
				showMedia: true,
				averageMiles,
				averageMessage,
				averageMilesSuggest,
				showConfiguracoesAvancadas
			},
			() => {
				let showBonus = this.isBonusAvailable();
				let bonusFields = this.getBonusFields(showBonus);

				if (
					!this.changingFidelity &&
					showBonus &&
					bonusFields.eligableColor == "green" &&
					this.state.eligableColor != bonusFields.eligableColor
				) {
					console.log("Alterou média de milhas para faixa dinâmica");
					PubSub.publish("dataLayer", {
						event: "gaEvent",
						gaEventCategory: "Minhas ofertas",
						gaEventAction: "Cadastro de oferta",
						gaEventLabel: "Alterou média de milhas para faixa dinâmica",
						gaEventValue: ""
					});
				}

				if (this.state.eligableColor != "red" && bonusFields.eligableColor == "red") {
					console.log("Exibição quer cadastrar um valor maior");
					PubSub.publish("dataLayer", {
						event: "gaEvent",
						gaEventCategory: "Minhas ofertas",
						gaEventAction: "Cadastro de oferta",
						gaEventLabel: "Exibição quer cadastrar um valor maior",
						gaEventValue: ""
					});
				}

				this.setState(bonusFields, () => {
					this.validatePrice(this.state.price);
				});
			}
		);
	};

	applySuggestion = () => {
		const { averageMilesSuggest } = this.state;
		this.searchAverage(averageMilesSuggest, averageMilesSuggest, undefined, averageMilesSuggest);
	};

	isValid = () => {
		// validar inputs/state
		const { fidelityId, quantMiles, price, errors, showMedia, averageMiles } = this.state;

		let valid =
			fidelityId && quantMiles && price && isAllFieldsEmpty(errors, "quantMiles", "price");
		if (showMedia && valid) {
			valid = averageMiles && isAllFieldsEmpty(errors, "averageMiles");
		}

		return valid;
	};

	// Avanca e salva os dados no state pai
	submitAndNextStep() {
		this.props.next(this.state);
	}

	// Atualiza o valor dos inputs
	validForm(event) {
		this.setState({ [event.target.name]: event.target.value });
	}

	validateQuantMiles(quantMiles) {
		const { errors, fidelity, fidelityId, valMinMiles, valMaxMiles } = this.state;
		quantMiles = quantMiles || this.state.quantMiles || 0;

		if (quantMiles >= valMinMiles && quantMiles <= valMaxMiles) {
			errors.quantMiles = "";
		} else if (quantMiles < valMinMiles) {
			errors.quantMiles = `A oferta precisa ter no mínimo ${intFormat(valMinMiles)} milhas`;
		} else {
			errors.quantMiles = `A oferta precisa ter no máximo ${intFormat(valMaxMiles)} milhas`;
		}
		this.setState({ errors });
		return !errors.quantMiles;
	}

	validatePrice(price) {
		const { errors, fidelityPrice, bonusMaxPrice, eligableColor } = this.state;
		let maxPrice = eligableColor == "green" ? bonusMaxPrice : fidelityPrice.maxPrice;
		price = price || this.state.price;

		if (!price) {
			errors.price = undefined;
		} else if (fidelityPrice && maxPrice >= price && fidelityPrice.minPrice <= price) {
			errors.price = "";
		} else {
			errors.price = `O valor precisa ser entre ${formatCurrency(
				fidelityPrice.minPrice
			)} e ${formatCurrency(maxPrice)}`;
		}

		this.setState({ errors });
		return !errors.price;
	}

	validateAverage(averageMiles, quantMiles, valMinMiles) {
		const { errors, fidelity } = this.state;
		const { hasManagementActive } = this.props;
		averageMiles = averageMiles != undefined ? averageMiles : this.state.averageMiles;
		quantMiles = quantMiles != undefined ? quantMiles : this.state.quantMiles;
		valMinMiles = valMinMiles != undefined ? valMinMiles : fidelity ? fidelity.valMinMiles : 0;

		if (averageMiles > quantMiles) {
			errors.averageMiles = `A média precisa ser menor que a ${intFormat(quantMiles)}`;
		} else if (averageMiles < valMinMiles) {
			errors.averageMiles = `A média precisa ser maior ou igual a ${intFormat(valMinMiles)} ${
				isMobile() ? "" : "milhas"
			}`;
		} else if (hasManagementActive && averageMiles > MANAGER_LIMIT_AVERAGE_MILES) {
			errors.averageMiles = `A média precisa ser menor ou igual a ${intFormat(
				MANAGER_LIMIT_AVERAGE_MILES
			)}`;
		} else {
			errors.averageMiles = "";
		}
		this.setState({ errors });
		return !errors.averageMiles;
	}

	changeAverageSlider(value) {
		const { mediasOptions, reducao } = this.state;

		if (reducao && reducao.value && mediasOptions && mediasOptions.length) {
			let option = mediasOptions.find(media => media.value == value);
			if (option) {
				this.changeMedia(option);
			}
		} else {
			this.searchAverage(value, value);
		}
	}

	cancelModal() {
		this.setState({ showZerarSimulador: false, pendentFidelityId: undefined });
	}

	confirmModal() {
		const { pendentFidelity } = this.state;

		// Não mostrar mais aviso
		localStorage.setItem("SimulatorMilesAviso", "1");
		this.changeFidelity(pendentFidelity);
	}

	calculatePositionCss() {
		const { averageMiles, startAverage, endAverage } = this.state;
		let slideMax = 30000;
		let averageLeft = (averageMiles / slideMax) * 100;
		let averageMargin = (startAverage / slideMax) * 100;
		averageMargin = averageMargin > 25 ? averageMargin - 0.5 : averageMargin; // calibra
		let averageWidth = ((endAverage - startAverage) / slideMax) * 100;
		averageWidth = averageWidth > 25 ? averageWidth - 0.5 : averageWidth; // calibra

		// Define limites pra nao sair fora da tela
		if (isMobile()) {
			averageLeft = averageLeft < 19 ? 19 : averageLeft > 51 ? 51 : averageLeft;
		} else {
			averageLeft = averageLeft < 6 ? 6 : averageLeft > 85 ? 85 : averageLeft;
		}

		return {
			averageLeft,
			averageMargin,
			averageWidth
		};
	}

	// Regra antiga!!! Agora os parâmetros para aplicar o bônus vem de um arquivo de configuração no S3
	isBonusAvailable() {
		const { fidelity, fidelityPrice } = this.state;
		return (
			fidelity &&
			fidelityPrice &&
			((fidelity.label == "Latam" &&
				fidelityPrice.passengersAvailable > Math.ceil(60000 / LATAM_BONUS_START_AVERAGE)) || // limite 14 cpf
				(fidelity.label == "Gol" &&
					fidelityPrice.passengersAvailable > Math.ceil(60000 / GOL_BONUS_START_AVERAGE))) // limite 5 cpf
		);
	}

	getBonusFieldsByLatam() {
		const { fidelityPrice, fidelity, averageMiles, quantMiles, reducao } = this.state;

		let passengersAvailable = fidelityPrice ? fidelityPrice.passengersAvailable : 0;
		let maxEligableQuant = passengersAvailable * LATAM_BONUS_END_AVERAGE;
		let minEligableQuant = Math.ceil(60000 / LATAM_BONUS_START_AVERAGE) * LATAM_BONUS_START_AVERAGE;

		let passengersCount = fidelityPrice ? parseInt((quantMiles || 0) / (averageMiles || 0)) : 0;
		passengersCount = passengersCount > passengersAvailable ? passengersAvailable : passengersCount;

		let eligableAverage =
			averageMiles < LATAM_BONUS_START_AVERAGE
				? ""
				: averageMiles > LATAM_BONUS_END_AVERAGE
				? "red"
				: "green";
		let eligableQuant =
			quantMiles >= minEligableQuant && fidelityPrice && quantMiles <= maxEligableQuant
				? "green"
				: "red";
		let eligableColor = eligableAverage == "green" && eligableQuant == "green" ? "green" : "red";

		return {
			passengersAvailable,
			maxEligableQuant,
			minEligableQuant,
			passengersCount,
			eligableAverage,
			eligableQuant,
			eligableColor,
			bonusMaxPrice: LATAM_BONUS_MAX_PRICE,
			startAverage: LATAM_BONUS_START_AVERAGE,
			endAverage: LATAM_BONUS_END_AVERAGE,
			bestAverage: LATAM_BONUS_BEST_AVERAGE
		};
	}

	getBonusFieldsByGol() {
		const { fidelityPrice, fidelity, averageMiles, quantMiles, reducao } = this.state;

		let passengersAvailable = fidelityPrice ? fidelityPrice.passengersAvailable : 0;
		let maxEligableQuant = passengersAvailable * GOL_BONUS_END_AVERAGE;
		let minEligableQuant = Math.ceil(60000 / GOL_BONUS_START_AVERAGE) * GOL_BONUS_START_AVERAGE;

		let passengersCount = fidelityPrice ? parseInt((quantMiles || 0) / (averageMiles || 0)) : 0;
		passengersCount = passengersCount > passengersAvailable ? passengersAvailable : passengersCount;

		let eligableAverage =
			averageMiles < GOL_BONUS_START_AVERAGE
				? ""
				: averageMiles > GOL_BONUS_END_AVERAGE
				? "red"
				: "green";
		let eligableQuant =
			quantMiles >= minEligableQuant && fidelityPrice && quantMiles <= maxEligableQuant
				? "green"
				: "red";
		let eligableColor = eligableAverage == "green" && eligableQuant == "green" ? "green" : "red";

		return {
			passengersAvailable,
			maxEligableQuant,
			minEligableQuant,
			passengersCount,
			eligableAverage,
			eligableQuant,
			eligableColor,
			bonusMaxPrice: GOL_BONUS_MAX_PRICE,
			startAverage: GOL_BONUS_START_AVERAGE,
			endAverage: GOL_BONUS_END_AVERAGE,
			bestAverage: GOL_BONUS_BEST_AVERAGE
		};
	}

	getBonusFields(showBonus) {
		const { fidelity } = this.state;

		if (showBonus && fidelity.label == "Latam") {
			return this.getBonusFieldsByLatam();
		}

		if (showBonus && fidelity.label == "Gol") {
			return this.getBonusFieldsByGol();
		}

		return {
			passengersAvailable: 0,
			maxEligableQuant: 0,
			minEligableQuant: 0,
			passengersCount: 0,
			eligableAverage: "",
			eligableQuant: "",
			eligableColor: "",
			bonusMaxPrice: 0,
			startAverage: 0,
			endAverage: 0
		};
	}

	hideAvisoVenda() {
		const { edit } = this.props;

		if (!edit) {
			this.setState({ showAvisoVenda: false });
		} else {
			window.location.href = ROUTE_HOME;
		}
	}

	hideAvisoParticipant() {
		window.location.href = ROUTE_HOME;
	}

	hideAvisoProblema() {
		const { edit } = this.props;

		if (!edit) {
			this.setState({ showAvisoProblema: false });
		} else {
			window.location.href = ROUTE_HOME;
		}
	}

	confirmNextStep() {
		const {
			fidelityPrice,
			price,
			averageMiles,
			showMedia,
			quantMiles,
			fidelity,
			errors
		} = this.state;
		let showBonus = this.isBonusAvailable();
		let textoAvisoConfirmar;

		if (fidelity.offerId && fidelityHasAverage(fidelity.value)) {
			if (fidelity.hasBonus) {
				const { eligableColor } = this.getBonusFields(showBonus);

				if (eligableColor == "red") {
					if (quantMiles < 60000) {
						textoAvisoConfirmar =
							"Com essa alteração de oferta, você deixará de ser elegível ao bônus para as próximas vendas. Deseja continuar?";
					} else {
						textoAvisoConfirmar =
							"Com essa alteração de oferta, você deixará de ser elegível ao bônus para as próximas vendas e iremos calcular a média de milhas por passageiro de suas vendas a partir de agora. Deseja continuar?";
					}
				}
			}
		}

		if (!this.isValid()) {
			if (!price) {
				errors.price = "Campo obrigatório";
			}
			if (!quantMiles) {
				errors.quantMiles = "Campo obrigatório";
			}
			if (fidelity == undefined || fidelity.value == "" || fidelity.value == undefined) {
				errors.fidelity = "Campo obrigatório";
			}
			if (showMedia) {
				if (!averageMiles) {
					errors.averageMiles = "Campo obrigatório";
				}
			}
			this.setState({ errors });
		} else if (textoAvisoConfirmar) {
			this.setState({ textoAvisoConfirmar, showAvisoConfirmar: true });
		} else if (!textoAvisoConfirmar && quantMiles >= 60000) {
			this.setState({ editarOfertaModal: true });
		} else {
			this.submitAndNextStep();
		}
	}

	changeReducao(option) {
		const { fidelityPrice, quantMiles, averageMilesSuggest } = this.state;
		let averageMiles = averageMilesSuggest || this.state.averageMiles;

		this.setState({ reducao: option });

		if (option.value > 0) {
			this.calcMedia(fidelityPrice.countAllowedSales, option, quantMiles);
		} else {
			this.searchAverage(averageMiles, averageMiles, undefined, averageMilesSuggest);
		}
	}

	changeMedia(option) {
		const { averageMilesSuggestionSelect, fidelity, stopAverageMessage } = this.state;

		let averageMessageSelect = findAverageMessage(
			option.value,
			averageMilesSuggestionSelect,
			fidelity,
			this.findStatisticalSales(option.value)
		);

		if (stopAverageMessage || !averageMessageSelect || averageMessageSelect.color != "red") {
			averageMessageSelect = undefined;

			this.setState({ media: option, averageMiles: option.value, averageMessageSelect }, () => {
				this.setState(this.getBonusFields(this.isBonusAvailable()), () => {
					this.validatePrice(this.state.price);
				});
			});
		} else {
			averageMessageSelect.text = (
				<div className={`average-message--${averageMessageSelect.color} no-border`}>
					{averageMessageSelect.text}
					<p>Você quer prosseguir com esta alteração?</p>
				</div>
			);

			this.setState({ mediaPendent: option, averageMessageSelect });
		}
	}

	confirmAverageSelect() {
		const { mediaPendent } = this.state;

		this.setState({
			media: mediaPendent,
			averageMiles: mediaPendent.value,
			averageMessageSelect: undefined,
			stopAverageMessage: true
		});
	}

	cancelAverageSelect() {
		this.setState({ averageMessageSelect: undefined, stopAverageMessage: true });
	}

	calcMedia(countAllowedSalesParam, reducao, quantMiles, averageMilesSaved) {
		const { averageMiles, errors, averageMilesSuggest } = this.state;
		const { hasManagementActive } = this.props;
		reducao = reducao || { value: 0 };
		let mediasOptions = [];
		let self = this;
		let restoMilhas = quantMiles - reducao.value * 35000;

		if (restoMilhas == 0) {
			mediasOptions.push({
				label: "ótima média",
				value: 35000,
				highlight: "35.000 milhas"
			});
		} else if (restoMilhas <= 1000) {
			mediasOptions.push({
				label: "35.000 milhas",
				value: 35000
			});
		} else {
			for (
				let countAllowedSales = countAllowedSalesParam;
				countAllowedSales > reducao.value;
				countAllowedSales--
			) {
				restoMilhas = parseInt(
					(quantMiles - 1000 - reducao.value * 35000) / (countAllowedSales - reducao.value)
				);
				if (
					restoMilhas >= 3500 &&
					restoMilhas < 100000 &&
					(!hasManagementActive || restoMilhas <= MANAGER_LIMIT_AVERAGE_MILES)
				) {
					restoMilhas = parseInt(quantMiles / countAllowedSales / 500) * 500;

					if (mediasOptions.find(m => m.value == restoMilhas)) {
						// Não adicionar repetidos
						continue;
					}

					mediasOptions.push({
						label: `${intFormat(String(restoMilhas))} milhas`,
						value: restoMilhas
					});
				}
			}
		}

		let media = mediasOptions[0];
		media =
			averageMilesSaved !== undefined
				? mediasOptions.find(m => m.value == averageMilesSaved)
				: media;

		if (!media) {
			if (averageMilesSaved) {
				if (reducao.value > 1) {
					let reducaoOptions = this.state.reducaoOptions;
					reducao = reducaoOptions[reducaoOptions.length - 1];
					this.setState({ reducao, reducaoOptions }, () => {
						self.calcMedia(countAllowedSalesParam, reducao, quantMiles);
					});
				} else {
					errors.averageMiles = "";
					this.setState({
						averageMiles: averageMilesSaved,
						averageMessage: findAverageMessage(averageMilesSaved),
						errors
					});
				}
			} else if (reducao.value > 1) {
				// Se tiver bônus ativo precisa cair no else
				// Decrementa 1 pra exibir menos redução
				let reducaoOptions = this.state.reducaoOptions.filter(r => r.value < reducao.value);
				reducao = reducaoOptions[reducaoOptions.length - 1];
				this.setState({ reducao, reducaoOptions }, () => {
					self.calcMedia(countAllowedSalesParam, reducao, quantMiles);
				});
			} else {
				// Se não tiver como decrementar, exibe input normal com possivel modal
				let reducaoOptions = [this.state.reducaoOptions[0]];

				let params = {
					reducaoOptions,
					reducao: reducaoOptions[0]
				};

				//if (!showBonus) {
				errors.averageMiles = averageMiles <= quantMiles ? "Campo obrigatório" : "";
				params.averageMiles = 0;
				params.averageMessage = findAverageMessage(0);
				params.errors = errors;
				//}

				this.setState(params);
			}
		} else {
			errors.averageMiles = media ? "" : "Campo obrigatório";
			this.setState(
				{
					mediasOptions,
					media,
					averageMiles: media.value,
					averageMilesSuggestionSelect: media.value,
					errors
				},
				() => this.changeMedia(media)
			);
		}
	}

	changeSmilesCheckbox(option) {
		const { fidelity, quantMiles, fidelityPrice, reducao, averageMilesSuggest } = this.state;
		let self = this;
		let checked = option[0].checked;
		let averageMiles = averageMilesSuggest || this.state.averageMiles;

		fidelity.isSmilesDiamond = checked;

		this.setState(
			{ fidelity, showSmilesCheckbox: true }, // Sempre seta o averageMiles pra ter o valor correto conforme muda o checked
			() => {
				if (checked) {
					self.calcMedia(fidelityPrice.countAllowedSales, reducao, quantMiles);
				} else {
					self.searchAverage(averageMiles, averageMiles, undefined, averageMilesSuggest);
				}
			}
		);
	}

	focusInputPrice() {
		if (this.inputPrice) {
			this.inputPrice.focus();
		}
	}

	showAndScrollToBonus() {
		this.setState({ showFidelityBonus: true }, () => {
			setTimeout(
				() =>
					window.scrollTo({
						top:
							document.querySelector(".header-bonus").getBoundingClientRect().top +
							window.scrollY -
							80,
						behavior: "smooth"
					}),
				200
			);
		});
	}

	render() {
		const {
			offers,
			fidelity: hideFidelity,
			dedicatedOffer,
			edit,
			hasManagementActive,
			hasRelationshipPendent,
			isIframe
		} = this.props;
		const {
			averageMiles,
			averageMilesSuggest,
			averageMessage,
			airlines,
			errors,
			locale,
			fidelity,
			fidelityId,
			fidelityPrice,
			price,
			quantMiles,
			priceState,
			ranks,
			showZerarSimulador,
			showAvisoVenda,
			showAvisoProblema,
			showMedia,
			valMaxMiles,
			valMinMiles,
			loadingPrice,
			fidelitiesOptions,
			showAvisoConfirmar,
			textoAvisoConfirmar,
			showConfiguracoesAvancadas,
			mediasOptions,
			reducaoOptions,
			reducao,
			media,
			showReducao,
			showAvisoMediaSaibaMais,
			averageMessageSelect,
			showSmilesCheckbox,
			passengersAvailable,
			maxEligableQuant,
			minEligableQuant,
			passengersCount,
			eligableAverage,
			eligableQuant,
			eligableColor,
			bonusMaxPrice,
			bestAverage,
			startAverage,
			endAverage,
			showFidelityBonus,
			editarOfertaModal
		} = this.state;

		let showBonus = this.isBonusAvailable();
		let bonusCssConfig = this.calculatePositionCss();
		let dedicatedOfferLoggedOut = dedicatedOffer && !getUserToken();

		let totalPrice = ((price || 0) * (quantMiles || 0)) / 1000;
		let maxSales = fidelityPrice ? fidelityPrice.countAllowedSales : 0;
		let maxMilesForReduction = maxSales > 1 ? (maxSales - 1) * 100000 + 35000 : 0;
		let newCountAllowedSales = 0;

		if (averageMiles && quantMiles >= 60000 && fidelityHasAverage(fidelity.value)) {
			newCountAllowedSales = averageMiles > 0 ? parseInt(quantMiles / averageMiles) : 0;
		} else {
			newCountAllowedSales = parseInt(quantMiles / valMinMiles);
		}

		if (newCountAllowedSales > maxSales) {
			newCountAllowedSales = maxSales;
		}

		const blockBonus = showBonus && showFidelityBonus && (
			<FidelityBonus
				bonusMaxPrice={bonusMaxPrice}
				bestAverage={bestAverage}
				eligableAverage={eligableAverage}
				eligableQuant={eligableQuant}
				eligableColor={eligableColor}
				averageMiles={averageMiles}
				startAverage={startAverage}
				endAverage={endAverage}
				bonusCssConfig={bonusCssConfig}
				maxEligableQuant={maxEligableQuant}
				minEligableQuant={minEligableQuant}
				changeAverageSlider={this.changeAverageSlider}
				fidelityLabel={fidelity && fidelity.label.toLowerCase()}
				focusInputPrice={this.focusInputPrice}
				validRange={reducao && reducao.value && mediasOptions}
				className={`simulator-miles simulator-miles--dynamic-range row no-margin ${
					dedicatedOffer ? "simulator-miles--dedicated" : ""
				} ${isIframe ? "simulator-miles--iframe" : ""}`}
			/>
		);

		let optionSmilesCheckbox = [
			{
				label: (
					<React.Fragment>
						Eu sou cliente Smiles da{" "}
						<a
							href="https://www.smiles.com.br/es/categorias-smiles#section-diamante"
							target="_blank"
						>
							Categoria Diamante.
						</a>
					</React.Fragment>
				),
				name: "smiles-diamante",
				checked: !!fidelity.isSmilesDiamond
			}
		];

		const blockSmilesCheckbox =
			((fidelity.label == "Gol" && fidelity.isSmilesDiamond == undefined) || showSmilesCheckbox) &&
			!hasManagementActive ? (
				<div className="row">
					<div className="col-md-16 smiles-checkbox">
						<Checkbox
							id="smiles-diamante"
							name="smiles-diamante"
							onChange={this.changeSmilesCheckbox}
							options={optionSmilesCheckbox}
							data-action="simulator-miles-smiles-diamante-checkbox"
						/>
					</div>
				</div>
			) : null;

		const blockPriceSuggestion = fidelityPrice && (
			<React.Fragment>
				<p className="text-right simulator-miles--suggest">
					Valor sugerido: <strong>{formatCurrency(fidelityPrice.valSuggestMin)}</strong> a{" "}
					<strong>{formatCurrency(fidelityPrice.valSuggestMax)}</strong>
				</p>
				{showMedia &&
					showBonus &&
					(eligableColor == "green" ? (
						<button
							className="btn btn-price-bonus btn-price-bonus--valid"
							type="button"
							data-action="simulator-miles-in-bonus-scroll"
							onClick={this.showAndScrollToBonus}
						>
							Você está dentro da faixa dinâmica
						</button>
					) : (
						<button
							className="btn btn-price-bonus btn-price-bonus--invalid"
							type="button"
							data-action="simulator-miles-out-bonus-scroll"
							onClick={this.showAndScrollToBonus}
						>
							Quer cadastrar um valor maior?
						</button>
					))}
			</React.Fragment>
		);

		const blockRankAndTotal = (
			<React.Fragment>
				{fidelityPrice && (
					<div className="simulator-miles--status-sale">
						<div className="col-xs-8 v-center-columns">
							{priceState && ranks && ranks.length > 0 && (
								<p className="no-margin">
									Sua posição:
									<strong className="position-value">{priceState.rank}°</strong>
								</p>
							)}
						</div>
						<div className="col-xs-8 v-center-columns text-right">
							{fidelityPrice && !isMobile() && !showMedia && (
								<div className="simulator-miles--suggest-div">{blockPriceSuggestion}</div>
							)}
							{/*priceState &&
								quantMiles < 600000 &&
								!fidelityHasAverage(fidelity.value) && (
									<p className="no-margin">
										<i className={`dot dot-${priceState.sale}`} />
										{PriceColorStatus[priceState.sale]}
									</p>
								)*/}
						</div>
					</div>
				)}

				{!isIframe && (
					<div className="col-xs-16">
						<hr />
					</div>
				)}

				<div className="col-xs-16 col-md-8 simulator-miles--ranking">
					{dedicatedOfferLoggedOut && !isIframe ? (
						<p className="simulator-miles--works" style={{ padding: "0" }}>
							Você pode adicionar <strong>uma única </strong> oferta{" "}
							<strong>por programa de fidelidade.</strong> A quantidade de milhas poderá ser
							reduzida ou aumentada através da edição da oferta.
						</p>
					) : null}
					{loadingPrice && <Loading label="Carregando valores" />}
					{ranks && (
						<div>
							{ranks.length > 0 ? (
								<React.Fragment>
									<h5>Ranking de Ofertas:</h5>

									{ranks &&
										ranks
											.filter((rank, idx) => idx < 5)
											.map((rank, position) => (
												<p key={position}>
													<strong>{position + 1}°</strong>
													<span>{formatCurrency(rank.price.replace(",", "."))}</span>({rank.name})
												</p>
											))}
								</React.Fragment>
							) : null}
						</div>
					)}
				</div>
				<div className={`col-xs-16 ${showMedia ? "col-md-16" : "col-md-8"} text-center`}>
					{loadingPrice && isIframe ? null : (
						<div className={`${showMedia ? "" : "col-md-offset-2"} simulator-miles--total`}>
							<p>
								Valor a receber
								<i
									className="tooltip gray"
									data-tooltip="Valor total a receber caso venda todas as milhas."
									data-flow="up"
								>
									?
								</i>
							</p>
							<strong className="simulator-miles--total-price">{formatCurrency(totalPrice)}</strong>
						</div>
					)}
				</div>
			</React.Fragment>
		);

		const blockInputMedia = (
			<React.Fragment>
				<div
					className="col-xs-16 input-average-wrapper"
					onClick={isMobile() ? () => scrollToComponent(".input-average-wrapper") : undefined}
				>
					<InputCurrency
						className="input-average"
						onChange={this.searchAverage}
						label="Média de milhas por passageiro:"
						placeholder={`Mínimo de ${intFormat(fidelity.valMinMiles || 3500)}`}
						decimalSeparator=","
						thousandSeparator="."
						precision="0"
						value={averageMiles}
						maxLength={7}
						disabled={!fidelityId || !fidelityPrice}
						errorMessage={errors.averageMiles}
						required
						data-action="simulator-miles-average-miles"
					/>

					<p className="average-suggestion">
						{averageMilesSuggest ? (
							<React.Fragment>
								Sugerida: <span>{intFormat(averageMilesSuggest)}</span>
								<i
									className="tooltip gray"
									data-tooltip="A MaxMilhas calculou a média ideal para que você venda todas as suas milhas o mais rápido possível."
									data-flow="up"
								>
									?
								</i>
								{/*<a onClick={this.applySuggestion} data-action="simulator-miles-average-apply">
									Aplicar média sugerida
								</a>*/}
							</React.Fragment>
						) : (
							<span>&nbsp;</span>
						)}
					</p>
				</div>
				{averageMessage && (
					<div className={`average-message average-message--${averageMessage.color}`}>
						{averageMessage.text}
						<div className={`floating-bar ${errors.averageMiles ? "has-error" : ""}`} />
						<div className={`input-floating-border ${errors.averageMiles ? "has-error" : ""}`}>
							A partir de:
						</div>
					</div>
				)}
			</React.Fragment>
		);

		const blockSelectMedia =
			reducao && reducao.value > 0 ? (
				<React.Fragment>
					<div className="col-xs-16 select-box-media">
						<p className="select-box-media--title">Média de milhas por passageiro:</p>
						<div
							className="select-box-media-wrapper"
							onClick={
								isMobile() ? () => scrollToComponent(".select-box-media-wrapper") : undefined
							}
						>
							<div className="select-box-media-wrapper--combo">
								<div className="select-box-media-wrapper--combo--start-point no-margin text-center">
									A partir de:
								</div>
								<div className="select-box-media-wrapper--combo--select-wrapper no-margin no-padding">
									<Select
										name="simulator-miles-media-select"
										onChange={this.changeMedia}
										selected={media || { label: "0 milhas" }}
										errorMessage={errors.averageMiles}
										options={mediasOptions}
										required
										data-action="simulator-miles-media-select"
									/>
								</div>
							</div>
							<p className="select-box-media-wrapper--description">
								Selecione uma das médias de milhas por passageiro que sugerimos para sua oferta de{" "}
								<strong>
									{intFormat(quantMiles)} milhas.{" "}
									<span
										className="select-box-media-wrapper--description--know-more"
										onClick={() => this.setState({ showAvisoMediaSaibaMais: true })}
									>
										Saiba mais.
									</span>
								</strong>
							</p>
						</div>
					</div>
				</React.Fragment>
			) : (
				blockInputMedia
			);

		const blockReducao =
			showReducao && fidelity.isSmilesDiamond ? (
				<React.Fragment>
					<div className="col-xs-16 select-box-passagem">
						<p className="select-box-passagem--title">
							Passagens com redução de milhas:
							<i
								className="tooltip gray"
								data-tooltip="Defina quantas passagens podemos emitir com o benefício de redução de milhas Diamante. Em cada uma delas, serão utilizadas 35.000 milhas. Quanto mais passagens você liberar, mais rápidas serão suas vendas."
								data-flow="up"
							>
								?
							</i>
						</p>
						<div className="select-box-passagem-wrapper">
							<div
								className="select-box-passagem-wrapper--combo"
								onClick={
									isMobile() ? () => scrollToComponent(".select-box-passagem-wrapper") : undefined
								}
							>
								<div className="select-box-passagem-wrapper--combo--start-point no-margin text-center">
									Permitir até:
								</div>
								<div className="select-box-passagem-wrapper--combo--select-wrapper no-margin no-padding">
									<Select
										name="simulator-miles-reducao-select"
										onChange={this.changeReducao}
										selected={reducao}
										errorMessage={errors.reducao}
										options={reducaoOptions}
										required
										data-action="simulator-miles-reducao-select"
										disabled={reducaoOptions.length == 1}
									/>
								</div>
							</div>
							{reducaoOptions.length == 1 ? (
								<React.Fragment>
									<p className="select-box-passagem-wrapper--alert">
										<span className="select-box-passagem-wrapper--alert-icon" />
										{showBonus ? (
											<React.Fragment>Campo desativado temporariamente.</React.Fragment>
										) : (
											<React.Fragment>
												Cadastre até <strong>{intFormat(maxMilesForReduction)} milhas</strong> para
												habilitar esse campo.
											</React.Fragment>
										)}
									</p>
									<hr />
								</React.Fragment>
							) : null}
							<p className="select-box-passagem-wrapper--description">
								Clientes Smiles da categoria Diamante podem resgatar até 10 passagens por ano
								utilizando no máximo 35.000 milhas, mesmo que o voo tenha uma quantidade de milhas
								maior para emissão.
							</p>
						</div>
					</div>
					{blockSelectMedia}
				</React.Fragment>
			) : null;

		const blockMedia = (
			<React.Fragment>
				<div className="col-xs-16 col-sm-8">
					<div
						className="row row-switch"
						style={{ marginTop: (isMobile() ? 0 : showMedia && showBonus ? -65 : -25) + "px" }}
					>
						<div className="col-xs-16">
							<Switch
								label="Configurações avançadas"
								onChange={checked => this.setState({ showConfiguracoesAvancadas: checked })}
								checked={showConfiguracoesAvancadas}
								data-action={
									showConfiguracoesAvancadas ? undefined : "simulator-miles-advanced-settings"
								}
							/>
						</div>
					</div>
					{showConfiguracoesAvancadas ? (
						<React.Fragment>
							{blockSmilesCheckbox}
							<div className="row">
								{showReducao && fidelity.isSmilesDiamond ? blockReducao : blockInputMedia}
							</div>
						</React.Fragment>
					) : null}
				</div>
				<div className="col-xs-16 col-sm-8">
					<div className="row">{blockRankAndTotal}</div>
				</div>
			</React.Fragment>
		);

		const blockBotoes = (
			<React.Fragment>
				<Steps
					next={this.confirmNextStep}
					prev={this.props.offer ? this.props.prev : undefined}
					prevText={this.props.offer ? "Voltar" : undefined}
					canPrev={!!this.props.offer}
					canNext={true}
					nextText={dedicatedOfferLoggedOut ? "Prosseguir" : undefined}
					dataActionNext="simulator-miles-next-button"
				>
					{!dedicatedOfferLoggedOut && !isIframe ? (
						<p className="simulator-miles--works">
							Você pode adicionar <strong>uma única </strong> oferta{" "}
							<strong>por programa de fidelidade.</strong>
							<br />A quantidade de milhas poderá ser reduzida ou aumentada através da edição da
							oferta.
						</p>
					) : null}
				</Steps>
			</React.Fragment>
		);

		return (
			<>
				<div
					className={`simulator-miles row no-margin ${
						dedicatedOffer ? "simulator-miles--dedicated" : ""
					} ${isIframe ? "simulator-miles--iframe" : ""}`}
				>
					<form className="form-offer block-center">
						<div className="row">
							{!dedicatedOffer && !edit && (
								<div className="col-xs-16 simulator-miles--locale form-group">
									<button
										type="button"
										className={`${!locale || locale != "1" ? "btn-gray-md-o" : "btn-green-md"}`}
										onClick={() => this.searchFidelities("1")}
										data-action="simulator-miles-national"
									>
										Nacional
									</button>
									<button
										type="button"
										className={`${!locale || locale != "2" ? "btn-gray-md-o" : "btn-green-md"}`}
										onClick={() => this.searchFidelities("2")}
										data-action="simulator-miles-international"
									>
										Internacional
									</button>
								</div>
							)}
							{!dedicatedOffer && !edit ? (
								<div className="col-xs-16">
									<Select
										onChange={this.changeFidelity}
										selected={fidelity}
										errorMessage={errors.fidelity}
										options={fidelitiesOptions}
										required
										dataActionFidelity={true}
										data-action="simulator-miles-fidelity-select"
									/>
									{fidelity && fidelity.value && (
										<p className="simulator-miles--link">
											Consulte seu saldo no site:
											<a
												target="_blank"
												href={fidelity.link}
												data-action="simulator-miles-fidelity"
											>
												{fidelity.name}
											</a>
										</p>
									)}
								</div>
							) : isIframe ? (
								<div className="col-xs-16">
									<h2 className="iframe-title">Quanto valem suas milhas? Simule aqui.</h2>
									<label className="label-span">
										<span>Qual programa de fidelidade?</span>
									</label>
									<Select
										onChange={this.changeFidelity}
										selected={fidelity}
										errorMessage={errors.fidelity}
										options={fidelitiesOptions}
										required
										dataActionFidelity={true}
										data-action="simulator-miles-fidelity-select"
									/>
								</div>
							) : null}
							{this.renderFidelityRadio()}
							<div className="col-xs-16 col-md-8">
								<InputCurrency
									label="Quantidade de milhas:*"
									placeholder={`Mínimo de ${intFormat(valMinMiles)}`}
									decimalSeparator=","
									thousandSeparator="."
									precision="0"
									value={quantMiles}
									onChange={this.searchPrices}
									debounce={500}
									tooltip="Informe a quantidade de milhas que deseja vender. Antes dá uma olhadinha se as milhas já estão disponíveis no programa de fidelidade selecionado."
									tooltipDirection={window.screen.availWidth < 1200 ? "up" : "right"}
									disabled={!fidelityId}
									maxLength={7}
									errorMessage={errors.quantMiles}
									tabIndex={1}
									required
									data-action="simulator-miles-quant-miles"
								/>
							</div>
							<div
								className="col-xs-16 col-md-8 miles-price"
								onClick={
									fidelityId && quantMiles && !loadingPrice && !errors.quantMiles && isMobile()
										? () => scrollToComponent(".miles-price")
										: undefined
								}
							>
								<InputCurrency
									onChange={this.searchPriceState}
									value={price}
									placeholder="0"
									label="Qual valor para cada 1.000 milhas?*"
									decimalSeparator=","
									thousandSeparator="."
									prefix="R$ "
									tooltip="Informe qual é o valor que você deseja receber por cada 1.000 milhas vendidas nesta oferta. O pagamento será feito 33 dias após a data da sua venda, na conta bancária cadastrada em nossa plataforma.  "
									tooltipDirection={window.screen.availWidth < 1200 ? "up" : "right"}
									maxLength={4}
									disabled={!fidelityId || !fidelityPrice}
									errorMessage={errors.price}
									tabIndex={2}
									required
									data-action="simulator-miles-price"
									refInput={input => {
										this.inputPrice = input;
									}}
								/>
								{fidelityPrice && (isMobile() || showMedia) && blockPriceSuggestion}
							</div>

							{showMedia ? blockMedia : blockRankAndTotal}

							{fidelityPrice &&
							fidelityHasAverage(fidelity.value) &&
							newCountAllowedSales &&
							!isIframe &&
							!dedicatedOfferLoggedOut ? (
								quantMiles < 60000 ? (
									<div className="col-xs-16 text-center">
										<p className="count-sales">
											Você poderá fazer até{" "}
											<strong>{`${newCountAllowedSales} venda${
												newCountAllowedSales > 1 ? "s" : ""
											}`}</strong>
											{quantMiles >= 35000 &&
											fidelity.isSmilesDiamond &&
											fidelityPrice.usedReductions < 10 ? (
												<React.Fragment>
													, sendo 1 delas com redução de milhas, se você for da categoria Diamante.{" "}
													<i className="tooltip blue" data-tooltip="Média de milhas" data-flow="up">
														?
													</i>
												</React.Fragment>
											) : (
												<React.Fragment> com essa oferta.</React.Fragment>
											)}
										</p>
									</div>
								) : (
									<div className="col-xs-16 text-center">
										<p className="count-sales">
											Com esta oferta, é possível fazer até{" "}
											<strong>{`${newCountAllowedSales} venda${
												newCountAllowedSales > 1 ? "s" : ""
											}`}</strong>
											{fidelity.isSmilesDiamond && reducao && reducao.value > 0
												? `, sendo no máximo ${reducao.value} delas com redução de milhas.`
												: "."}
										</p>
									</div>
								)
							) : null}
						</div>
					</form>
				</div>
				{showMedia && showBonus ? blockBonus : null}
				<div
					className={`simulator-miles row no-margin ${
						dedicatedOffer ? "simulator-miles--dedicated" : ""
					} ${isIframe ? "simulator-miles--iframe" : ""}`}
				>
					{dedicatedOffer ? (
						<div className="form-offer block-center">
							<div className="row">{blockBotoes}</div>
						</div>
					) : (
						blockBotoes
					)}
				</div>
				{this.props.children}
				<Modal
					title="IMPORTANTE"
					description={textoAvisoConfirmar}
					cancel="Voltar"
					confirm="Ok, continuar"
					show={showAvisoConfirmar}
					onCancel={() => this.setState({ showAvisoConfirmar: false })}
					onConfirm={() => this.submitAndNextStep()}
					fixed={true}
				/>
				<EditarOfertaModal
					show={editarOfertaModal}
					onCancel={() => this.setState({ editarOfertaModal: false })}
					onConfirm={() => this.submitAndNextStep()}
				/>
				<Modal
					title="ZERAR O SIMULADOR!?"
					description="Caso confirme a mudança do programa de fidelidade, os dados informados (quantidade de milhas e preço) terão que ser preenchidos novamente."
					cancel="Fechar"
					confirm="Ok, prosseguir"
					show={showZerarSimulador}
					onCancel={this.cancelModal}
					onConfirm={this.confirmModal}
					fixed={true}
				/>
				<OfertaEmVendaModal show={showAvisoVenda} onConfirm={this.hideAvisoVenda} />
				<VinduloPendenteModal
					show={!!hasRelationshipPendent}
					onConfirm={this.hideAvisoParticipant}
				/>
				<Modal
					title="OFERTA NÃO APROVADA"
					description="Infelizmente sua oferta anterior não foi aprovada. Não será possível cadastrar uma nova oferta para este programa de fidelidade."
					confirm="Fechar"
					show={showAvisoProblema}
					onCancel={this.hideAvisoProblema}
					onConfirm={this.hideAvisoProblema}
				/>
				<Modal
					title="MÉDIA DE MILHAS POR PASSAGEIRO"
					description="Podemos emitir passagens com quantidade de milhas menor ou maior do que a média informada. No fim das vendas, a média de milhas por passageiro será igual ou superior à desta oferta."
					confirm="Ok, entendi"
					show={showAvisoMediaSaibaMais}
					onCancel={() => this.setState({ showAvisoMediaSaibaMais: false })}
					onConfirm={() => this.setState({ showAvisoMediaSaibaMais: false })}
				/>
				<Modal
					title="ATENÇÃO"
					description={averageMessageSelect ? averageMessageSelect.text : ""}
					cancel="Fechar"
					confirm="Ok, prosseguir"
					show={!!averageMessageSelect}
					onCancel={this.cancelAverageSelect}
					onConfirm={this.confirmAverageSelect}
					height={300}
				/>{" "}
				<Modal
					title="ATENÇÃO"
					description="A Venda Rápida não poderá ser utilizada nesta oferta, mas continue anunciando suas milhas! Vamos direcionar você para nossa Venda Convencional, combinado?"
					confirm="Ok, entendi"
					show={this.state.showModalQuickSaleProblem}
					onCancel={() => this.setState({ showModalQuickSaleProblem: false })}
					onConfirm={() => this.setState({ showModalQuickSaleProblem: false })}
					dataActionConfirm="quick-sale-modal-invalid-offer"
				/>
			</>
		);
	}
}

export default SimulatorMiles;
